export const SLIDES = [
  {
    img: 'assets/images/carousel1.png',
    name: 'Patricia Ayala',
    title: 'home.loggedOut.testimonials.slides.patricia.quote',
    author: 'Patricia Ayala',
    facility: 'home.loggedOut.testimonials.slides.patricia.facility',
  },
  {
    img: 'assets/images/carousel2.png',
    name: 'Maya Mathur',
    title: 'home.loggedOut.testimonials.slides.maya.quote',
    author: 'Maya Mathur',
    facility: 'home.loggedOut.testimonials.slides.maya.facility',
  },
  {
    img: 'assets/images/carousel3.png',
    name: 'Philip Cohen',
    title: 'home.loggedOut.testimonials.slides.philip.quote',
    author: 'Philip Cohen',
    facility: 'home.loggedOut.testimonials.slides.philip.facility',
  },
];

export const INTEGRATION_ICONS = [
  {
    title: 'home.loggedOut.integrations.categories.authentication',
    first: {
      path: 'assets/images/integrations/incommon.png',
      height: '36',
      width: '200',
    },
    second: {
      path: 'assets/images/integrations/sso.png',
      height: '59',
      width: '135',
    },
  },
  {
    title: 'home.loggedOut.integrations.categories.discovery',
    first: {
      path: 'assets/images/integrations/google-scholar.png',
      height: '36',
      width: '215',
    },
    second: {
      path: 'assets/images/integrations/orcid.png',
      height: '34',
      width: '111',
    },
  },
  {
    title: 'home.loggedOut.integrations.categories.references',
    first: {
      path: 'assets/images/integrations/mendeley.png',
      height: '42',
      width: '214',
    },
    second: {
      path: 'assets/images/integrations/zotero.png',
      height: '36',
      width: '152',
    },
  },
  {
    title: 'home.loggedOut.integrations.categories.storage',
    first: {
      path: 'assets/images/integrations/dropbox.png',
      height: '34',
      width: '175',
    },
    second: {
      path: 'assets/images/integrations/google-drive.png',
      height: '35',
      width: '207',
    },
  },
];
